import styled from 'styled-components'

export const Container = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.secondary.ultraLighten};
  padding: 12px 16px;
  display: flex;
  justify-content: ${({ isEmpty }) => (isEmpty ? 'center' : 'space-between')};
  align-content: center;
`

export const CenterText = styled.div`
  margin: 0;
  align-self: center;
`

export const MontoText = styled(CenterText)`
  margin-right: 8px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    margin: 0;
  }
`

export const HowToText = styled.div`
  margin: 0;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 12px;
`
